(() => {
  const content = document.getElementById('article-content');
  const tocNav = document.getElementById('article-toc-list');
  const tocWrap = document.querySelector('.article-detail__toc');

  if (!content || !tocNav || !tocWrap) return;

  const SCROLL_OFFSET = 110;
  const headings = content.querySelectorAll('h2');

  if (!headings.length) {
    tocWrap.classList.add('is-empty');
    tocNav.innerHTML = '<p style="font-size: 12px;color: #AFAFB3;">No headings found</p>';
    return;
  }

  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const usedIds = new Set();
  const items = [];

  headings.forEach((heading) => {
    let id = heading.id;
    if (!id) {
      id = slugify(heading.textContent || 'section');
      let uniqueId = id || 'section';
      let i = 2;
      while (usedIds.has(uniqueId)) {
        uniqueId = `${id}-${i++}`;
      }
      id = uniqueId;
      heading.id = id;
    }
    usedIds.add(id);
    items.push({
      heading,
      id,
      level: parseInt(heading.tagName.charAt(1), 10)
    });
  });

  const list = document.createElement('ul');
  list.className = 'article-detail__toc-list';

  items.forEach(({ heading, id, level }) => {
    const li = document.createElement('li');
    li.className = `article-detail__toc-item article-detail__toc-item--h${level}`;
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = (heading.textContent || '').trim();
    li.appendChild(link);
    list.appendChild(li);
  });

  tocNav.appendChild(list);

  const links = list.querySelectorAll('a');

  const scrollToHeading = (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
    });
  };

  const getActiveHeading = () => {
    let activeId = items[0]?.id;
    items.forEach(({ heading, id }) => {
      const rect = heading.getBoundingClientRect();
      if (rect.top <= SCROLL_OFFSET + 8) {
        activeId = id;
      }
    });
    return activeId;
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      setActive(getActiveHeading());
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const targetId = link.getAttribute('href').slice(1);
      scrollToHeading(targetId);
      setActive(targetId);
    });
  });

  setActive(items[0].id);
})();
